(function () {
  'use strict';

  var AUTOPLAY_INTERVAL = 2800; /* ms between slides */

  function initSlider(slider) {
    var slides  = Array.from(slider.querySelectorAll('.cpr__slide'));
    var dots    = Array.from(slider.querySelectorAll('.cpr__dot'));
    var current = 0;
    var timer   = null;

    if (slides.length < 2) return;

    function goTo(index) {
      slides[current].classList.remove('cpr__slide--active');
      dots[current].classList.remove('cpr__dot--active');
      dots[current].setAttribute('aria-selected', 'false');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('cpr__slide--active');
      dots[current].classList.add('cpr__dot--active');
      dots[current].setAttribute('aria-selected', 'true');
    }

    function next() {
      goTo(current + 1);
    }

    function startAutoplay() {
      timer = setInterval(next, AUTOPLAY_INTERVAL);
    }

    function resetAutoplay() {
      clearInterval(timer);
      startAutoplay();
    }

    /* Dot clicks — reset timer so manual tap gets a full interval before next auto-advance */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10));
        resetAutoplay();
      });
    });

    /* Touch swipe — also resets timer */
    var touchStartX = 0;
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].screenX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
        resetAutoplay();
      }
    }, { passive: true });

    /* Pause on hover (desktop) */
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.cpr__slider').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
